<template>
  <div class="details-complete pb-4">
    <div class="details-wrapper">

      <div class="builder-bike mt-0 mb-6"/>

      <h1 class="bb-primary--text mb-6">
        YOUR BUILD
      </h1>

      <div v-if="company && company.summaryHtml" v-html="company.summaryHtml"></div>
      <div v-else>
        <p>
            Thank you for creating your dream build with Velodrom. Whatever combination you've
            chosen we'll ensure that it all works together and, of course, fits you perfectly.
        </p>

        <p>
            Get in touch to discuss your requirements in more detail, and for impartial expert
            advice on bike and component choice.
        </p>
      </div>

      <div class="overview-figures mb-6">
        <Price
          class="d-inline-block"
          :price="price"
          :offer="specialBuild && specialBuild.price"
        >
          <template v-slot:right>
            <BtnSpecialBuild
              v-if="specialBuild"
              @click="$emit('special-build')"
              right
            />
          </template>
        </Price>
        <WeightEstimate class="details-weight" :weight="weight" large/>
      </div>

      <div class="overview-primary-actions">
        <Btn color="bb-primary" height="44" dark @click="$emit('quote')">Contact us today</Btn>
        <Btn height="44" outlined :loading="pdfBusy" :disabled="pdfBusy" @click="$emit('download-pdf')">Download PDF</Btn>
        <Btn class="btn-form footer-enquire body-1" color="bb-secondary" @click="$emit('form')" height="40" tile dark>
          <v-icon left v-text="'mdi-bookmark-outline'"/>
          Save the build
        </Btn>
      </div>

      <v-alert v-if="pdfError" type="error" text dense role="alert">{{ pdfError }}</v-alert>

      <div class="detail-actions mt-6">

        <Btn class="outline light--border mr-3" color="bb-primary" width="40" height="40" @click="$emit('share')" icon>
          <v-icon v-text="'mdi-share-variant'"/>
        </Btn>

        <Btn
          class="outline light--border mr-3"
          href="https://web.whatsapp.com/send?phone=34652923272&text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20que%20me%20ayudaras%20con...."
          width="40" height="40"
          title="¿Cómo puedo ayudarte?"
          color="bb-primary"
          target="_blank"
          icon
        >
          <v-icon v-text="'mdi-whatsapp'"/>
        </Btn>

        <Btn
          class="btn-print outline light--border"
          color="bb-primary"
          width="40" height="40"
          title="Imprimir"
          @click="$emit('print')"
          icon
        >
          <v-icon v-text="'mdi-printer'"/>
        </Btn>
      </div>
    </div>

    <BuildSpecification :items="items" :weight="weight" />

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Btn, BtnSpecialBuild, Price } from '@/components';
import BuildSpecification from './BuildSpecification';
import WeightEstimate from './WeightEstimate';

export default {
  components: { Btn, Price, BtnSpecialBuild, BuildSpecification, WeightEstimate },
  props: {
    print: Boolean,
    pdfBusy: Boolean,
    pdfError: String,
    items: Array,
    price: Number,
    weight: Object,
    specialBuild: Object
  },
  computed: {
    ...mapState(['company'])
  }
}
</script>

<style>
.overview-figures { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 12px 40px; }
.details-complete {
  padding-top: 32px;
}
.details-complete p {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
.details-complete > .details-wrapper {
  padding-right: 720px;
}
.details-complete .builder-bike {
  display: none;
}
@media(max-width:993px) {
  .details-complete {
    text-align: center;
    padding-top: 0;
  }
  .details-complete > .details-wrapper {
    padding-right: 0;
  }
  .details-complete .builder-bike {
    display: block;
  }
}
@media ( max-width: 480px ) {
  .btn-print {
    display: none !important;
  }
}
</style>

<style>
.overview-primary-actions { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 16px; }
.overview-primary-actions .v-btn { text-transform: none; letter-spacing: 0; border-radius: 6px; }
@media (max-width: 600px) { .overview-primary-actions .v-btn { width: 100%; } }
@media print { .overview-primary-actions { display: none; } }
</style>
